import { StorageKeys } from '@base/utils/constants';
import { ILocalStorage } from '../storage/interfaces';
import { FONT_SIZES, THEMES } from './interfaces';
import { BehaviorSubject } from 'rxjs';

type Layout = { font: FONT_SIZES; theme: THEMES };

export interface IThemeService {
  layout: BehaviorSubject<Layout>;
  setFontSize(size: FONT_SIZES): void;
  setColorTheme(theme: THEMES): void;
}

export default class ThemeService implements IThemeService {
  DEFAULT_LAYOUT = {
    font: FONT_SIZES.M,
    theme: THEMES.GREEN,
  };

  layout = new BehaviorSubject<Layout>(this.DEFAULT_LAYOUT);

  constructor(private localStorage: ILocalStorage) {
    const savedLayout = this.localStorage.get(StorageKeys.LAYOUT) || this.DEFAULT_LAYOUT;
    this.setFontSize(savedLayout.font);
    this.setColorTheme(savedLayout.theme);
  }

  setFontSize(font: FONT_SIZES): void {
    this.localStorage.update(StorageKeys.LAYOUT, { font });
    this.updateLayout();
  }

  setColorTheme(theme: THEMES): void {
    this.localStorage.update(StorageKeys.LAYOUT, { theme });
    this.updateLayout();
  }

  private updateLayout() {
    const layout: Layout = this.localStorage.get(StorageKeys.LAYOUT);
    document.documentElement.style.fontSize = layout.font;
    document.documentElement.className = layout.theme;
    this.layout.next(layout);
  }
}
